import type { ExistingFileController } from "@/hooks/use-existing-file-controller";
import { PickProjectGalleryFilesModal } from "@/modals/projects/pick-project-gallery-files-modal";
import { Button } from "@msuite/ui/button";
import type { FileUploadController } from "@msuite/ui/file-upload";
import { useDisclosure } from "@msuite/ui/hooks";
import { useTranslation } from "@msuite/ui/localization";
import type { Tables } from "@msuite/utils/types";

/** Props Interface */
interface ProjectTimelineNoteFormSelectExistingFilesProps {
	controller: FileUploadController;
	projectId: string;
	existingFileController: ExistingFileController;
}

export function ProjectTimelineNoteFormSelectExistingFiles({
	controller,
	projectId,
	existingFileController,
}: ProjectTimelineNoteFormSelectExistingFilesProps) {
	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Functions */
	function handleOnComplete(fileIds: string[]) {
		if (fileIds.length < 1) return;
		controller.handleOnAddDefaultFiles(fileIds.map((id) => ({ id }) as Tables<"files">));
		existingFileController.handleOnAddPendingFileIds(fileIds);
	}

	/** Render */
	return (
		<>
			<div className="h-stack justify-center mt-2">
				<Button
					variant="white"
					onClick={disclosure.onOpen}
					data-cy="project-timeline-note-select-existing-files-button"
				>
					{t("general.select_existing_files")}
				</Button>
			</div>
			{disclosure.isOpen && (
				<PickProjectGalleryFilesModal
					projectId={projectId}
					excludeFileIds={[
						...controller.defaultFiles.map((file) => file.id),
						...existingFileController.pendingFileIds,
					]}
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={handleOnComplete}
				/>
			)}
		</>
	);
}
